"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var settings_1 = __importDefault(require("./settings"));
var utils_1 = require("./utils");
var Service = /** @class */ (function () {
    function Service() {
    }
    // TODO: deprecated
    Service.prototype.get = function (params, mode) {
        return new Promise(function (resolve, reject) {
            var queryParams = utils_1.mountSearchParams(params);
            var request = new XMLHttpRequest();
            request.addEventListener('load', resolve);
            request.addEventListener('error', reject);
            request.addEventListener('abort', reject);
            request.open('GET', "" + settings_1.default[mode].url + (queryParams ? "?" + queryParams : queryParams), true);
            request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            request.send();
        });
    };
    Service.prototype.send = function (eventHub, mode) {
        var data = JSON.stringify(eventHub);
        return this.request(data, settings_1.default[mode].url + "/event/json");
    };
    Service.prototype.sendMetrify = function (hubMetrify, mode) {
        if (hubMetrify.event.params && typeof hubMetrify.event.params === 'object') {
            hubMetrify.event.params = JSON.stringify(hubMetrify.event.params);
        }
        var data = JSON.stringify(hubMetrify);
        return this.request(data, settings_1.default[mode].url + "/event/json");
    };
    Service.prototype.request = function (data, url) {
        return new Promise(function (resolve, reject) {
            if (navigator && navigator.sendBeacon) {
                var status_1 = navigator.sendBeacon(url, data);
                status_1 ? resolve() : reject();
                return;
            }
            var request = new XMLHttpRequest();
            request.addEventListener("load", resolve);
            request.addEventListener("error", reject);
            request.addEventListener("abort", reject);
            request.open("POST", url);
            request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            request.send(data);
        });
    };
    return Service;
}());
exports.default = new Service();
